import { Box, Grid } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import OtDataGrid from "../../../components/dataGridOt";
import OtTimeSeriesChart from "../../../components/OtTimeSeriesChart";

dayjs.extend(utc);
dayjs.extend(timezone);

const OtReads = () => {
  const [checkReady, setCheckReady] = useState(false);
  const [rows, setRows] = useState([]);
  const [anomalyLoading, setAnomalyLoading] = useState(true);
  const [timeFilter, setTimeFilter] = useState(null);
  const [signalRows, setSignalRows] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tz = window.sessionStorage.getItem("timezone") || "Etc/GMT";
  const [payload, setPayload] = useState({
    dateFrom: "",
    dateTo: "",
    detail: "",
    exact_detail: "",
    tipo: 3,
    isWrite: false,
    isPrivateSource: "",
    isPrivateDestination: "",
  });

  useEffect(() => {
    let dateFrom;
    let dateTo;
    const exact_detail = queryParams.get("exact_details");
    const detail = queryParams.get("details");
    const ipSource = queryParams.get("ipSource");
    const ipDestination = queryParams.get("ipDestination");
    const isPrivateSource = queryParams.get("isPrivateSource");
    const isPrivateDestination = queryParams.get("isPrivateDestination");

    if (queryParams.get("clickedData")) {
      dateFrom = dayjs.tz(queryParams.get("clickedData"), tz).startOf("hour");
      dateTo = dateFrom.endOf("hour").millisecond(0);
    } else if (queryParams.get("advtimeStamp")) {
      dateFrom = dayjs.tz(queryParams.get("advtimeStamp"), tz).startOf("day");
      dateTo = dayjs.tz(queryParams.get("advtimeStamp"), tz).endOf("day").millisecond(0);
    } else if (queryParams.get("dateFrom") && queryParams.get("dateTo")) {
      dateFrom = dayjs.tz(queryParams.get("dateFrom"), tz);
      dateTo = dayjs.tz(queryParams.get("dateTo"), tz).endOf("day").millisecond(0);
    } else {
      dateFrom = dayjs().tz(tz).subtract(1, "hour");
      dateTo = dayjs().tz(tz);
    }

    setPayload((prev) => ({
      ...prev,
      dateFrom,
      dateTo,
      detail: detail || "",
      exact_detail: exact_detail || "",
      ipsource: ipSource || "",
      ipDestination: ipDestination || "",
      isPrivateSource,
      isPrivateDestination,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- queryParams is a new URLSearchParams object every render; adding it (and tz) would refire this mount-only effect and re-trigger setPayload on every render
  }, []);

  useEffect(() => {
    const hasRequiredFields =
      payload.dateFrom && payload.dateFrom !== "" && payload.dateTo && payload.dateTo !== "";
    setCheckReady(hasRequiredFields);
    if (hasRequiredFields) {
      setAnomalyLoading(true);
      setTimeFilter([payload.dateFrom.toISOString(), payload.dateTo.toISOString()]);
    }
  }, [payload]);

  return (
    <Box m="20px">
      <Grid container>
        <Grid size={12} sx={{ display: "flex", justifyContent: "space-between" }}>
          <Header
            sx={{ width: { xs: "40vw", md: "" } }}
            title="OT Reads"
            subtitle=""
            desc="Read operations from Industrial Protocol logs. Select a signal to see its value trend against historical statistical reference (IQR band, median, mean, fences)."
          />
        </Grid>
        <Grid size={12}>
          <OtTimeSeriesChart
            rows={rows}
            loading={anomalyLoading}
            timeFilter={timeFilter}
            onSignalChange={(_, sRows) => setSignalRows(sRows.length > 0 ? sRows : null)}
          />
        </Grid>
        <Grid size={12}>
          {checkReady ? (
            <OtDataGrid
              tipo={3}
              mode="r"
              passedPayload={payload}
              localRows={signalRows}
              onRowsLoaded={(newRows) => {
                setRows(newRows);
                setAnomalyLoading(false);
              }}
            />
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};

export default OtReads;
